import { useContext } from 'react'
import { ErrorBannerContext } from './ErrorBannerProvider'

export const useErrorBanner = () => {
	return useContext(ErrorBannerContext)
}
